@if (attraction) {
    <div class="attraction-card">
        <div class="attraction-card__header">
            @if (attraction.imageUrl; as imageUrl) {
                <figure>
                    <img [src]="imageUrl | safeUrl" alt="country-image">
                </figure>
            }
        </div>
        <div class="attraction-card__content">
            <h3>{{ attraction.name }}</h3>

            <div class="attraction-card__row">
                <p class="attraction-card__description"
                   [innerHtml]="attraction.thingsTodoDescription"></p>
            </div>
        </div>
        <div class="attraction-card__footer">
            <button class="attraction-card__read-more btn-default btn-blue" (click)="handleShowAttraction($event)">
                Read more
            </button>
        </div>
    </div>
}
